export interface AgeniumSession {
    sessionId: string;
    applicationId: string | null;
}

export async function getAgeniumSession(appId?: string): Promise<AgeniumSession> {
    const resp = await fetch(`/api/agenium/session?applicationId=${appId}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!resp.ok) throw new Error('There was an error fetching the agenium session');

    const json = await resp.json();
    return json.data;
}
